export const createReducer =
  <S>(initialState: S, reducers: { [key: string]: (s: S, a: any) => S }) =>
  (state = initialState, action: any): S =>
    reducers[action.type] ? reducers[action.type](state, action) : state;
